
export default {
    setDeficiencia(state, data) {
        state.deficiencia = data
    },
    setDeficiencias(state, data) {
        state.deficiencias = data
    },
}